module.exports = __webpack_public_path__ + "static/media/paymentMethod.2a64e288.svg";